

<app-lp-menu></app-lp-menu>


<header>
  <div class="hero grid grid-nogutter text-800">
    <div class="hero-text text-left flex align-items-center ">
      <div class="">
        <h1 class="title">Ušetřete si čas<br>při pořádání a prodeji
          <span class="title-part">
            {{ magicText }}
          </span>
        </h1>
        <p class="title-detail-text">
          Lektory je <b>systém</b> pro <b>organizaci a prodej kurzů</b>, workshopů, festivalů, konferencí a dalších on-line či on-site událostí. Vyřeší za vás administrativu a vy se tak můžete věnovat více tomu co vás baví.
        </p>


        <div class="flex column-gap-3 flex-wrap align-items-baseline">

          <!-- <div class="flex flex-column">
            <button
              class="hero-btn gradient">
              Vyzkoušet zdarma
            </button>

            <p class="m-0 mt-2 text-gray-400 text-center">
              Bez nutnosti zadání kreditní karty
            </p>
          </div> -->

          <div class="flex flex-column">
            <button
              (click)="onArrangeDemo()"
              class="hero-btn hero-btn--gradient arrange-demo-btn">
              Domluvit online konzultaci
            </button>

            <p class="m-0 mt-2 text-gray-400 text-center">
              Nezávazně na 30 min. online.
            </p>
          </div>
        </div>

        
      </div>
    </div>
    <div class="hero-image relative overflow-hidden h-full">
      <ng-container *ngFor="let img of heroImageArray; let i = index">
        <img *ngIf="heroActiveImage == img" [@enterAnimation] (@enterAnimation.done)="onHeroAnimationDone(heroActiveImage == img)" [ngSrc]="img" alt="Lektory" fill class="absolute heading-image block md:ml-auto md:h-full" style="object-fit: 'cover'"/>
      </ng-container>
    </div>
  </div>
</header>

<div *ngFor="let img of heroImageArray; let i = index" class="relative" style="width: 0; height: 0; overflow: 'hidden';">
  <img [priority]="i === 0" [ngSrc]="img" fill/>
</div>

<div class="container-lg">
  
  <section class="for-whom relative" [class.opacity-0]="hideWhomSection">  
  
    <p class="col-12 text-green-500 m-0 section-pretitle -mb-2">
      Pro koho je Lektory?
    </p>
  
    <ngx-masonry [ordered]="true" [updateLayout]="updateMasonryLayout" class="relative z-0">
  
      <div ngxMasonryItem class="col-12 md:col-6">
        <h2 class="text-dark-blue section-title m-0">
          Systém na míru potřebám týmů <span class="text-green-500">lektorů</span> a <span class="text-green-500">organizátorů</span>
        </h2>
      </div>
  
      <div ngxMasonryItem class="col-12 md:col-6">
  
        <div class="card">
          <div class="card-title">
            Pořádání dlouhodobých kurzů
          </div>
  
          <div class="card-text">
            pro děti i dospělé.
          </div>
        </div>
  
      </div>
  
      <div ngxMasonryItem class="col-12 md:col-6">
  
        <div class="card">
          <div class="card-title">
            Organizace tanečních festivalů
          </div>
  
          <!-- <div class="card-text">
          </div> -->
        </div>
  
      </div>
  
      <div ngxMasonryItem class="col-12 md:col-6">
  
        <div class="card">
          <div class="card-title">
            Jednorázové workshopy, semináře a webináře
          </div>
  
          <div class="card-text">
            pro jednotlivce, skupiny či firmy.
          </div>
        </div>
  
      </div>
  
      <div ngxMasonryItem class="col-12 md:col-6">
  
        <div class="card">
          <div class="card-title">
            Konference a kongresy
          </div>
  
          <!-- <div class="card-text">
          </div> -->
        </div>
  
      </div>
  
      <div ngxMasonryItem class="col-12 md:col-6">
  
        <div class="card">
          <div class="card-title">
            Služby na objednávku
          </div>
  
          <div class="card-text">
            Kurzy a akce na míru • programy pro žáky/školy
          </div>
        </div>
  
      </div>
  
    </ngx-masonry>
  
  </section>

  <section>
    <div class="banner grid gradient">
      <div class="col-12 md:col-6 lg:col-6">
        <h3 class="banner-title">
          Zjistěte, jak lze využít Lektory.app při prodeji a pořádání vašich událostí.
        </h3>
  
        <!-- <p class="banner-text">

        </p> -->
      </div>

      <!-- spacer -->
      <div class="col-0 lg:col-1"></div>

      <div class="col-12 md:col-6 lg:col-5 flex align-items-center">
        <button
          (click)="onArrangeDemo()"
          class="hero-btn hero-btn--white flex-1 arrange-demo-btn">
          Domluvit nezávaznou konzultaci
        </button>
      </div>
    </div>
  </section>

  <section class="connect">

    <div class="grid">

      <h2 class="col-12 section-title text-dark-blue m-0 mb-3">
        Lektory rozšíří váš web o:
      </h2>

      <div class="col-12 md:col-6 flex flex-column row-gap-4">


        <div class="card">
          <div class="span card-number">
            1
          </div>

          <div class="card-title">
            <span class="text-green-500">
              Přívětivý
            </span> rezervační systém pro vaše zákazníky
          </div>
  
          <div class="card-text">
            na různé typy událostí, jednorázových i dlouhodobých kurzů, workshopů, festivalů či konferencí. Pro jednotlivce, skupiny, dospělé i děti.
          </div>
        </div>

        <div class="card">
          <div class="span card-number">
            2
          </div>

          <div class="card-title">
            Nákupní košík
          </div>
  
          <div class="card-text">
            díky kterému vaši zákazníci neztratí přehled o svých nákupech na vaší akci.   
          </div>
        </div>

        <div class="card">
          <div class="span card-number">
            3
          </div>

          <div class="card-title">
            Online platby
          </div>
  
          <div class="card-text">
            klasickým převodem nebo platební kartou. Lektory za vás pak mj. potvrzuje přijetí platby, vystavuje doklady, hlídá splatnost objednávek nebo zákazníkům připomíná opožděné platby.
          </div>
        </div>

      </div>

      <div class="col-12 md:col-6 p-5 flex align-items-center">
        <img src="assets/images/lp/phone.png" alt="Phone" class="w-full">
      </div>

    </div>

  </section>
  
  <section id="features" class="features">
  
    <div class="grid">
  
      <div class="col-12 md:col-6">
        <div class="f-intro-card">
  
          <h2 class="f-intro-card-title section-title">
            Funkce, které vám <span class="underline">usnadní</span> <span class="text-indigo-700"> organizaci</span> a <span class="text-green-500">podpoří prodej</span>
          </h2>
    
          <p class="f-intro-card-text text-xl">
            vašich kurzů, workshopů, konferencí, festivalů a dalších on-site či on-line událostí.
          </p>
  
        </div>
  
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-calendar"></i>
          </div>
  
          <h3 class="icon-card-title">
            Vypisování a plánování
          </h3>
  
          <p class="icon-card-text">
            Jednoduše vypíšete nabídku vašich jednorázových i vícedenních akcí, kurzů, workshopů nebo produktů či služeb.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--green">
            <i class="pi pi-chart-line"></i>
          </div>
  
          <h3 class="icon-card-title">
            Rezervace a objednávky
          </h3>
  
          <p class="icon-card-text">
            Naplánujete si čas otevření rezervací, systém za vás pak eviduje a potvrzuje rezervace, kontroluje kapacitu, úhrady, připomíná klientům opožděné platby a další ...
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-list"></i>
          </div>
  
          <h3 class="icon-card-title">
            Chytré formuláře
          </h3>
  
          <p class="icon-card-text">
            které se neptají znovu klientů na to co už o nich víte. Sběr informací nutných pro registraci na akci máte plně pod kontrolou.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--green">
            <i class="pi pi-percentage"></i>
          </div>
  
          <h3 class="icon-card-title">
            Slevy a promokódy
          </h3>
  
          <p class="icon-card-text">
            Za pomoci široké palety slev a promokódů můžete motivovat k zákazníky k dalšímu nákupům a podpořit tak prodeje.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-chart-pie"></i>
          </div>
  
          <h3 class="icon-card-title">
            Reporty
          </h3>
  
          <p class="icon-card-text">
            Máte přehled o přijatých platbách, počtech rezervací, objednávek a jejich stavu.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-cog"></i>
          </div>
  
          <h3 class="icon-card-title">
            Automatická fakturace
          </h3>
  
          <p class="icon-card-text">
            Při nákupu na organizaci automaticky vystavíme fakturu a hlídáme její úhradu.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-users"></i>
          </div>
  
          <h3 class="icon-card-title">
            Týmové role
          </h3>
  
          <p class="icon-card-text">
            Lektory.app je informační systém pro celý váš tým.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--green">
            <i class="pi pi-euro"></i>
          </div>
  
          <h3 class="icon-card-title">
            Online platby
          </h3>
  
          <p class="icon-card-text">
            Platby kartou, QR, bankovním převodem, bankovní tlačítka, ...
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-chart-bar"></i>
          </div>
  
          <h3 class="icon-card-title">
            Prezenčky a docházka
          </h3>
  
          <p class="icon-card-text">
            Díky sledování docházky můžete předejít předčasnému odchodu vašich zákazníků u dlouhodobých kurzů.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-clock"></i>
          </div>
  
          <h3 class="icon-card-title">
            Výkazy práce a mzdy
          </h3>
  
          <p class="icon-card-text">
            Systém vám na konci měsíce připraví podklady pro vyplacení mezd lektorů vč. náhrad za cestovné a pod.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-history"></i>
          </div>
  
          <h3 class="icon-card-title">
            Zákaznická historie
          </h3>
  
          <p class="icon-card-text">
            nákupů, plateb, objednávek, a dřívější komunikace vám umožní rychle řešit dotazy klientů a budovat skvělou zákaznickou podporu.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-check-square"></i>
          </div>
  
          <h3 class="icon-card-title">
            Zákaznické souhlasy
          </h3>
  
          <p class="icon-card-text">
            Jedno místo s přehledem o udělených a odebraných souhlasech vašich klientů se zpracováním jejich dat.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-comments"></i>
          </div>
  
          <h3 class="icon-card-title">
            Komunikace s klienty
          </h3>
  
          <p class="icon-card-text">
            Na pár kliknutí odešlete zprávu vašim vybraným klientům.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-star"></i>
          </div>
  
          <h3 class="icon-card-title">
            Nabídky služeb na míru
          </h3>
  
          <p class="icon-card-text">
            V Lektory.app klientům snadno sestavíte webovou nabídku služeb na míru. Klienti mohou na pár kliků objednat, zaplatit a získat doklad.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--red">
            <i class="pi pi-phone"></i>
          </div>
  
          <h3 class="icon-card-title">
            Automatické vystavování certifikátů
          </h3>
  
          <p class="icon-card-text">
            po ukončení kurzu na základě docházky.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 lg:col-3">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--green">
            <i class="pi pi-map-marker"></i>
          </div>
  
          <h3 class="icon-card-title">
            Pronájem místností
          </h3>
  
          <p class="icon-card-text">
            Míváte volné prostory?<br>Pronajměte je svým klientům.
          </p>
  
        </div>
      </div>
  
  
      <div class="col-12 md:col-6">
  
        <div class="f-intro-card">
  
          <h2 class="f-intro-card-title section-title">
            ...a další vychytávky, které vám a <span class="underline">vašemu týmu</span> <span class="text-green-500"> ušetří</span> každodenní <span class="text-green-500">práci</span>.
          </h2>
    
          <!-- <p class="f-intro-card-text">
          </p> -->
  
        </div>
  
      </div>
  
    </div>
  
  </section>
  
  <section>
    <div class="banner grid gradient">
      <div class="col-12 md:col-6 lg:col-6">
        <h3 class="banner-title">
          Zjistěte, jak lze využít Lektory.app při prodeji a pořádání vašich událostí.
        </h3>
  
        <!-- <p class="banner-text">

        </p> -->
      </div>

      <!-- spacer -->
      <div class="col-0 lg:col-1"></div>

      <div class="col-12 md:col-6 lg:col-5 flex align-items-center">
        <button
          (click)="onArrangeDemo()"
          class="hero-btn hero-btn--white flex-1 arrange-demo-btn">
          Domluvit nezávaznou konzultaci
        </button>
      </div>
    </div>
  </section>
  
  <section id="pricing" class="pricing">

    <div class="grid pricing-wrap">

      <div class="col-12 md:col-6">

        <p class="section-pretitle text-green-500 m-0">
          Kolik to stojí?
        </p>
    
        <h2 class="section-title my-1">
          Cenový model
        </h2>
    
        <p class="text-2xl text-gray-800">
          Cena kompletní služby je stanovena jako <span class="text-green-500 font-bold">2,5% poplatek</span> z koncové ceny zpracovaných objednávek. 
        </p>
    
        <p class="text-gray-600 text-lg">
          Poplatky jsou vyúčtovány vždy na konci měsíce. Službu lze hradit také formou ročního předplatného. Za příjem registrací na vaše kurzy zdarma poplatky neúčtujeme.
        </p>

      </div>

      <div class="hidden md:block col-12 md:col-1"></div>
      <div class="hidden md:block col-12 md:col-4">
        <div class="flex align-items-center justify-content-center">
          <img src="assets/images/lp/pricing-pie.svg" class="w-full" style="height: 21rem;">
        </div>
      </div>
      <div class="hidden md:block col-12 md:col-1"></div>

      <app-lp-pricing-variants></app-lp-pricing-variants>

      <p><span class="font-bold">Hledáte specifickou funkci a nemůžete ji zde najít?</span> Napište nám na info&#64;lektory.app</p>


    </div>


  </section>
  
  <section class="why">
  
    <h2 class="section-title">
      Proč Lektory?
    </h2>
  
    <div class="grid">
  
      <div class="col-12 sm:col-6 md:col-4">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--red">
            <i class="pi pi-phone"></i>
          </div>
  
          <h3 class="icon-card-title">
            Nepřetržitá podpora
          </h3>
  
          <p class="icon-card-text">
            Jsme připraveni vám poradit, ve chvíli, kdy budete potřebovat.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 md:col-4">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--purple">
            <i class="pi pi-cloud-upload"></i>
          </div>
  
          <h3 class="icon-card-title">
            Migrace dat zdarma
          </h3>
  
          <p class="icon-card-text">
            Potřebujete přenést data z vašich excelů či jiných nástrojů? Náš tým vám s tím rád pomůže.
          </p>
  
        </div>
      </div>
  
      <div class="col-12 sm:col-6 md:col-4">
        <div class="icon-card">
  
          <div class="icon-card-icon icon-card-icon--green">
            <i class="pi pi-dollar"></i>
          </div>
  
          <h3 class="icon-card-title">
            Žádné skryté poplatky
          </h3>
  
          <p class="icon-card-text">
            Jednoduchý cenový model dostupný pro malé a flexibilní pro velké organizace.
          </p>
  
        </div>
      </div>
  
    </div>
  
  </section>

  <section>
    <div class="banner grid gradient relative overflow-hidden">
      <div class="col-12 md:col-6">
        <h3 class="banner-title">
          Přizpůsobeno pro mobilní zařízení
        </h3>
  
        <p class="banner-text">
          Abyste mohli spravovat svoje události jednoduše odkudkoliv.
        </p>
      </div>

      <div class="hidden md:block md:col-6">
        <img src="assets/images/lp/phone-banner.png" class="h-full" style="max-width: 45%; position: absolute; top: 0; right: -5px;">
      </div>
    </div>
  </section>

  <section id="faq" class="faq">

    <div class="grid">

      <div class="col-12 sm:col-5 md:col-4">
        <h2 class="section-title">
          Časté dotazy
        </h2>

        <p>
          Nenašli jste odpověď na váš dotaz? Kontaktujte nás na info&#64;lektory.app nebo si s námi domluvte schůzku.
        </p>

        <button
          (click)="onArrangeDemo()"
          class="hero-btn hero-btn--gradient arrange-demo-btn">
          Domluvit online konzultaci
        </button>
      </div>

      <div class="col-12 sm:col-7 md:col-8">

        <div *ngFor="let item of faqItems" (click)="item.active = !item.active" class="faq-item">

          <div class="faq-item-head">

            <div class="faq-item-dot" [class.faq-item-dot--active]="item.active"></div>

            <h5 class="faq-item-title">
              {{ item.title }}
            </h5>

            <div class="faq-item-head-icon">
              <i *ngIf="!item.active" class="pi pi-chevron-down"></i>
              <i *ngIf="item.active" class="pi pi-chevron-up"></i>
            </div>
          </div>

          <div [@collapse]="!item.active" class="faq-item-body">
            <p>
              {{ item.text }}
            </p>
          </div>

        </div>
        
      </div>

    </div>

  </section>

  <section>
    <div class="banner grid gradient">
      <div class="col-12 md:col-6 lg:col-6">
        <h3 class="banner-title">
          Zjistěte, jak si <span class="underline">pomocí automatizace</span> ušetřit práci a administrativu.
        </h3>
  
        <!-- <p class="banner-text">

        </p> -->
      </div>

      <!-- spacer -->
      <div class="col-0 lg:col-1"></div>

      <div class="col-12 md:col-6 lg:col-5 flex align-items-center">
        <button
          (click)="onArrangeDemo()"
          class="hero-btn hero-btn--white flex-1 arrange-demo-btn">
          Domluvit nezávaznou konzultaci
        </button>
      </div>
    </div>
  </section>

</div>



<!-- <section class="create-event-section surface-section">

  <div class="create-event-wrap p-5 shadow-5 mx-auto border-round-2xl relative surface-card">
    <app-lp-create-event></app-lp-create-event>
  </div>

</section> -->


<app-lp-footer></app-lp-footer>



<!-- <ng-template #featureItem let-heading="heading" let-text="text">
  <div class="flex align-items-center mb-4">
    <i class="pi pi-check text-green-600 mr-3"></i>
    <div>
        <div class="text-900 font-medium">{{ heading }}</div>
        <div *ngIf="text" class="text-700 text-sm mt-2">{{ text }}</div>
    </div>
  </div>
</ng-template>
 -->



<!-- <app-sign-in></app-sign-in> -->
